import { Injectable } from "@angular/core";
import { TipoArquivo } from '@tivic-team/manager-ts/dist/grl/entities/tipo-arquivo.entity';
import { HttpGet, JSONData, Quark, Url, HttpResponse, HttpPost, HttpPut } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";



@Injectable()
export class TiposArquivosController{

    constructor() {}

    async get(cdTipoArquivo: number): Promise<TipoArquivo> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/arquivos/tipos/:cdTipoArquivo',
                    environment: environment,
                    pathParams: new JSONData({cdTipoArquivo: cdTipoArquivo})
                }),
            }),
            new HttpResponse(
                new TipoArquivo()
            )
        );

        return await quark.call();
    }

    async find(filtros?: IFilter): Promise<Array<TipoArquivo>> {
        let quark =  new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/arquivos/tipos',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<TipoArquivo>()
            )
        );

        return await quark.call();
    }

    async create(tipoArquivo: TipoArquivo): Promise<TipoArquivo> {
        let quark =  new Quark(
            new HttpPost({
                url: new Url({
                    id: 'grl/arquivos/tipos',
                    environment: environment
                }),
                data: new JSONData(tipoArquivo)
            }),

            new HttpResponse(
                new TipoArquivo()
            )
        );

        return await quark.call()
    }

    async update(tipoArquivo: TipoArquivo): Promise<TipoArquivo>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'grl/arquivos/tipos/:cdTipoArquivo',
                    environment: environment,
                    pathParams: new JSONData({ cdTipoArquivo: tipoArquivo.cdTipoArquivo })
                }),
                data: new JSONData(tipoArquivo)
            }),
            new HttpResponse(
                new TipoArquivo()
            )
        );

        return await quark.call();
    }
}